import { AppImages } from "app/appImages";
import { GenericAbortSignal } from "axios";
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { IAutoCompleteProps } from "components/MprcAutoComplete/AutoComplete";
import { GroupType, MemberAutoCompleteDataModelDto, MemberType } from "generated/CoreApi_v1";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";

////////////////////////////////////////////////////////////////////////////

export type MemberAutoCompleteQueryParams = {
  pageNumber: number;
  pageSize: number;
  searchText?: string | null;
};

interface IProps {
  groupType?: GroupType;
  exceptGroupId?: string;
  onGetDataCustom?: (data: MemberAutoCompleteQueryParams, signal: GenericAbortSignal | undefined) => Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>;
}

type Props = IProps & Omit<IAutoCompleteProps, 'onGetSuggestions' | 'emptyThumbnail' | 'onDisplayThumbnail'>;

////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de seleção de membros
 * @param props
 */
export const MemberAutoComplete: React.FC<Props> = (props) => {
  const api = useCoreApi();

  const { onError, onGetDataCustom } = props;

  ///
  const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
    searchText = searchText.toLowerCase();
    if (onGetDataCustom != undefined) {
      return onGetDataCustom({ pageNumber, pageSize, searchText }, signal);
    } else {
      return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
        api.v1.suggestions.managedMember({
          searchText,
          exceptGroupIds: props.exceptGroupId != null ? [props.exceptGroupId] : [],
          ignoreSelectionHistory: true,
          pageNumber: pageNumber,
          pageSize: pageSize,
        }, { signal })
          .then(result => {
            resolve({
              items: result.data.items as AutoCompleteDataModel[],
              totalRows: result.data.totalRows
            });
          })
          .catch(error => {
            if (!isCanceledError(error)) {
              resolve({ items: [], totalRows: 0 });
              if (onError) onError(error);
            }
          });
      });
    }
  };

  ////////////////////////////////////////////////////////////////////////////
  /// RENDER
  ////////////////////////////////////////////////////////////////////////////

  return (
    <MprcAutoComplete
      {...props}
      required
      onDisplayThumbnail={
        (item) => {
          const member = item as MemberAutoCompleteDataModelDto;
          return member.memberType == MemberType.User
            ? AppImages.UserThumbnail
            : AppImages.GroupThumbnail;
        }
      }
      onGetSuggestions={getSuggestions}
    />
  );
};
